import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import $ from 'jquery';
library.add(faBars);
library.add(faPlus);
library.add(faSearch);
library.add(faTimes);
$(document).ready(function () {
  // Use FontAwesome 5 to setup static SVG icons within the header/footer.
  //
  // Only replace icons in the header/footer portions that are explicitly
  // wrapped in an `enable-template-icons` class, so that our template icons
  // don't interfere with any FontAwesome usage (of different versions) in the
  // content/body portion of the app.
  var nodes = document.querySelectorAll('.enable-template-icons');

  for (var i = 0, len = nodes.length; i < len; i++) {
    dom.i2svg({
      node: nodes[i]
    });
  }
});